import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface MergeInventoryItemsRequest {
    parent_uuid: string
    children_uuids: string[]
}

export interface MergeInventoryItemsErrorResponse {
    message: string
    errors?: {
        parent_uuid?: string[]
        children_uuids?: string[]
        [key: string]: string[] | undefined
    }
}

export default (axios: AxiosInstance = baseAxios): { mergeItems: (request: MergeInventoryItemsRequest) => Promise<void>; } => ({
    mergeItems: async (request: MergeInventoryItemsRequest): Promise<void> => {
        await axios.post('/api/inventory/merge', request);
    },
});
